import styled from 'styled-components';
import { useReturnExchangeArchivesValueContextHook } from '../../../../contexts/ReturnExchangeArchivesContext';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .tag{
    color: #333;
    border-radius: 3px;
    border: 1px solid #efefef;
    background-color: #efefef;
    font-weight: 600;
    font-size: 12px;
    padding: 3px 5px;
    min-width: 40px;
    width: fit-content;
    text-align: center;
  }
`

export function TdArchive({
    returnExchange
}) {
    const returnExchangeArchivesValueContextHook = useReturnExchangeArchivesValueContextHook();
    const returnExchangeArchives = returnExchangeArchivesValueContextHook?.returnExchangeArchives;

    const returnExchangeArchive = returnExchangeArchives?.find(r => r._id === returnExchange.returnExchangeArchiveId);
    return (
        <>
            <StyledTableCell>
                <div className='tag' style={{backgroundColor: returnExchangeArchive?.backgroundColor || '#EFEFEF', color: returnExchangeArchive?.fontColor || '#333333'}}>
                    {returnExchangeArchive ? returnExchangeArchive.name : '-'}
                </div>
            </StyledTableCell>
        </>
    );
}